import { ReactNode } from 'react';

import { useUserContext } from '../useUserContext';

interface RestrictAccessProps {
    allowPermissions: string[];
    render?: () => ReactNode;
    fallBackComponent?: ReactNode;
    children?: ReactNode;
}

export const RestrictAccess = ({
    allowPermissions,
    render,
    fallBackComponent,
    children,
}: RestrictAccessProps) => {
    // TODO - find out where this is coming from and what the possible values are. Ticket for this: HDP-3973
    const { permissionsBySection } = useUserContext();

    if (
        // TODO - refactor this to make it more readable. Ticket for this: HDP-3973

        permissionsBySection &&
        allowPermissions &&
        allowPermissions.some(allowPermission => {
            const [sectionName, permissionName] = allowPermission.split('.');
            if ((permissionsBySection[sectionName] || {})[permissionName])
                return true;
        })
    ) {
        return children;
    }

    if (render) {
        return render();
    }

    if (fallBackComponent) {
        return fallBackComponent;
    }

    return null;
};
